import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { LOCATION_CHANGE } from './actions';
export var createRouterReducer = function createRouterReducer(_ref) {
  var _ref$savePreviousLoca = _ref.savePreviousLocations,
    savePreviousLocations = _ref$savePreviousLoca === void 0 ? 0 : _ref$savePreviousLoca,
    basename = _ref.basename;
  var initialState = {
    location: null,
    action: null,
    basename: basename
  };
  // eslint-disable-next-line no-restricted-globals
  var numLocationToTrack = isNaN(savePreviousLocations) ? 0 : savePreviousLocations;
  if (numLocationToTrack) initialState.previousLocations = [];
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref2.type,
      payload = _ref2.payload;
    if (type === LOCATION_CHANGE) {
      var _ref3 = payload || {},
        location = _ref3.location,
        action = _ref3.action;
      var previousLocations = numLocationToTrack // @ts-ignore
      ? [{
        location: location,
        action: action
      }].concat(_toConsumableArray(state.previousLocations.slice(0, numLocationToTrack))) : undefined;
      return Object.assign(Object.assign({}, state), {
        location: location,
        action: action,
        previousLocations: previousLocations
      });
    }
    return state;
  };
};